import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';
import 'scss-templates/t-contactus.scss';
import 'scss-templates/t-service-page.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'SizeSelectorComponent',
      'SizeTableSwitcherComponent',
      'PdpMainComponent',
      'PdpImagesComponent',
      'SkuInfoAccordionComponent',
      'AddToCartComponent',
      'NotifyMeComponent',
      'RecommendationEngineComponent',
      'EditorialCoverInfiniteComponent',
      'SimpleBarComponent',
      'GoogleRecommendationEngineComponent',
      'DoubleLaunchComponent',
      'ContactUsComponent',
      'ContactUsComponent',
      'DatePickerComponent',
      'RecaptchaComponent',
      'NewPrivacyComponent'
    ];
  }
}
